import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { H1 } from 'UIComponents/elements/headings';
import { HubProductHeader } from './HubProductHeader';
import ResourceLinks from './suite-starter-page/ResourceLinks';

const FeatureContent = ({
  apiName,
  upgradeConfig
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(HubProductHeader, {
      apiName: apiName
    }), /*#__PURE__*/_jsx(H1, {
      className: "m-bottom-10",
      children: upgradeConfig.title
    }), /*#__PURE__*/_jsx("p", {
      className: "text-left",
      "data-test-id": "upgrade-modal-subtitle",
      dangerouslySetInnerHTML: {
        __html: upgradeConfig.subtitle
      }
    }), /*#__PURE__*/_jsx(ResourceLinks, {
      upgradeConfig: upgradeConfig
    })]
  });
};

export default FeatureContent;